import { OPENAI_VOICE_GENDER, type OpenAiVoiceGender } from "./openaiVoices";

export type VoiceGender = OpenAiVoiceGender;
export const VOICE_LIBRARY = Object.entries(OPENAI_VOICE_GENDER).map(([id, gender]) => ({
  id, gender, displayName: id.charAt(0).toUpperCase() + id.slice(1),
}));
export const getVoicesByGender = (gender: VoiceGender) => VOICE_LIBRARY.filter((v) => v.gender === gender);
